module.exports = __webpack_public_path__ + "static/media/remember_04.799b1347.png";